<template>
  <div>
    <h4 class="font-weight-bold pa-3 mb-0">
      BIK / Perquisite / VOLA
    </h4> 

    <v-row class="px-3">
      <v-col
        cols="12"
        class="py-0"
      > 
        <h5 class="font-weight-bold my-0">
          Benefit In Kind
        
          <employee-profile-payroll-payroll-company-benefit-in-kind-bik-dialog-create
            v-if="$hasPermissionTo(['create employee payroll']) && !companyEmployee.end_date"
            :company-employee-uid="companyEmployee.company_employee_uid"
            :company-employee-start-date="companyEmployee.start_date"
            @created="$emit('load')"
          />
        </h5>
      </v-col>

      <v-col
        v-if="benefitInKinds.length > 0"
        cols="2"
        class="pb-0 text-left"
      >
        <span class="font-weight-bold">Type</span>  
      </v-col>
      <v-col
        v-if="benefitInKinds.length > 0"
        cols="2"
        class="pb-0 text-center"
      >
        <span class="font-weight-bold">Start Date</span>
      </v-col>
      <v-col
        v-if="benefitInKinds.length > 0"
        cols="2"
        class="pb-0 text-center"
      >
        <span class="font-weight-bold">End Date</span>
      </v-col>
      <v-col
        v-if="benefitInKinds.length > 0"
        cols="2"
        class="pb-0 text-center"
      >
        <span class="font-weight-bold">Amount (RM)</span>
      </v-col>
      <v-col
        v-if="benefitInKinds.length > 0"
        cols="4"
        class="pb-0 text-center"
      />

      <v-col
        v-if="benefitInKinds.length > 0"
        cols="12"
        class="pt-0"
      >
        <v-row
          v-for="benefitInKind in benefitInKinds"
          :key="benefitInKind.id"
          no-gutters
        >
          <v-col
            cols="2"
            class="text-left"
          >
            <v-tooltip
              bottom
              min-width="250"
            >
              <template v-slot:activator="{ on: tooltip }">
                <v-icon
                  class="pr-1"
                  small
                  color="info"
                  v-on="{ ...tooltip }"
                >
                  mdi-information-outline
                </v-icon>
              </template>
              <div>Created by: <b>{{ benefitInKind.created_by }}</b> on <b>{{ $moment(benefitInKind.created_at).format('DD-MM-YYYY') }}</b></div>
              <div>Updated by: <b>{{ benefitInKind.updated_by }}</b> on <b>{{ $moment(benefitInKind.updated_at).format('DD-MM-YYYY') }}</b></div>
            </v-tooltip>

            <span>{{ benefitInKind.benefit_in_kind.name }}</span>
          </v-col>
          <v-col
            cols="2"
            class="text-center px-3"
          >
            <span>{{ benefitInKind.start_date ? $moment(benefitInKind.start_date).format('D MMM YYYY'):'N/A' }}</span>
          </v-col>
          <v-col
            cols="2"
            class="text-center px-3"
          >
            <span>{{ benefitInKind.end_date ? $moment(benefitInKind.end_date).format('D MMM YYYY'):'N/A' }}</span>
          </v-col>
          <v-col
            cols="2"
            class="text-right px-3"
          >
            <span>{{ thousandSeparator(twoDigit(benefitInKind.amount)) }}</span>
          </v-col>
          <v-col
            cols="4"
            class="text-center px-3"
          >
            <employee-profile-payroll-payroll-company-benefit-in-kind-bik-dialog-edit
              v-if="$hasPermissionTo(['update employee payroll']) && !companyEmployee.end_date && !benefitInKind.end_date"
              :benefit-in-kind="benefitInKind"
              :company-employee-start-date="companyEmployee.start_date"
              @updated="$emit('load')"
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col
        v-else
        class="py-0"
        cols="12"
      >
        <span>No Data Available</span>
      </v-col>
    </v-row>
    <v-divider />

    <v-row class="px-3">
      <v-col
        cols="12"
        class="py-0"
      > 
        <h5 class="font-weight-bold my-0">
          Perquisites
          <employee-profile-payroll-payroll-company-benefit-in-kind-perquisite-dialog-create
            v-if="$hasPermissionTo(['create employee payroll']) && !companyEmployee.end_date"
            :company-employee-uid="companyEmployee.company_employee_uid"
            :company-employee-start-date="companyEmployee.start_date"
            @created="$emit('load')"
          />
        </h5>
      </v-col>

      <v-col
        v-if="perquisites.length > 0"
        cols="2"
        class="pb-0 text-left"
      >
        <span class="font-weight-bold">Type</span>  
      </v-col>
      <v-col
        v-if="perquisites.length > 0"
        cols="2"
        class="pb-0 text-center"
      >
        <span class="font-weight-bold">Start Date</span>
      </v-col>
      <v-col
        v-if="perquisites.length > 0"
        cols="2"
        class="pb-0 text-center"
      >
        <span class="font-weight-bold">Tax Exemption</span>
      </v-col>
      <v-col
        v-if="perquisites.length > 0"
        cols="2"
        class="pb-0 text-center"
      >
        <span class="font-weight-bold">Amount (RM)</span>
      </v-col>
      <v-col
        v-if="perquisites.length > 0"
        cols="4"
        class="pb-0 text-center"
      />

      <v-col
        v-if="perquisites.length > 0"
        cols="12"
        class="pt-0"
      >
        <v-row
          v-for="perquisite in perquisites"
          :key="perquisite.id"
          no-gutters
        >
          <v-col
            cols="2"
            class="text-left"
          >
            <v-tooltip
              bottom
              min-width="250"
            >
              <template v-slot:activator="{ on: tooltip }">
                <v-icon
                  class="pr-1"
                  small
                  color="info"
                  v-on="{ ...tooltip }"
                >
                  mdi-information-outline
                </v-icon>
              </template>
              <div>Created by: <b>{{ perquisite.created_by }}</b> on <b>{{ $moment(perquisite.created_at).format('DD-MM-YYYY') }}</b></div>
              <div>Updated by: <b>{{ perquisite.updated_by }}</b> on <b>{{ $moment(perquisite.updated_at).format('DD-MM-YYYY') }}</b></div>
            </v-tooltip>

            <span>{{ perquisite.benefit_in_kind.name }}</span>
          </v-col>
          <v-col
            cols="2"
            class="text-center px-3"
          >
            <span>{{ perquisite.start_date ? $moment(perquisite.start_date).format('D MMM YYYY'):'N/A' }}</span>
          </v-col>
          <v-col
            cols="2"
            class="text-center px-3"
          >
            <span>{{ perquisite.tax_exemption ? perquisite.tax_exemption.name : '' }}</span>
          </v-col>
          <v-col
            cols="2"
            class="text-right px-3"
          >
            <span>{{ thousandSeparator(twoDigit(perquisite.amount)) }}</span>
          </v-col>
          <v-col
            cols="4"
            class="text-center px-3"
          >
            <employee-profile-payroll-payroll-company-benefit-in-kind-perquisite-dialog-edit
              v-if="$hasPermissionTo(['update employee payroll']) && !companyEmployee.end_date"
              :perquisite="perquisite"
              :company-employee-start-date="companyEmployee.start_date"
              @updated="$emit('load')"
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col
        v-else
        class="py-0"
        cols="12"
      >
        <span>No Data Available</span>
      </v-col>
    </v-row>
    <v-divider />
    <v-row class="px-3">
      <v-col
        cols="12"
        class="py-0"
      > 
        <h5 class="font-weight-bold my-0">
          Value of Living Accomodations
          <employee-profile-payroll-payroll-company-benefit-in-kind-vola-dialog-create
            v-if="$hasPermissionTo(['create employee payroll']) && !companyEmployee.end_date"
            :company-employee-uid="companyEmployee.company_employee_uid"
            :company-employee-start-date="companyEmployee.start_date"
            @created="$emit('load')"
          />
        </h5>
      </v-col>

      <v-col
        v-if="volas.length > 0"
        cols="2"
        class="pb-0 text-left"
      >
        <span class="font-weight-bold">Type</span>  
      </v-col>
      <v-col
        v-if="volas.length > 0"
        cols="2"
        class="pb-0 text-center"
      >
        <span class="font-weight-bold">Start Date</span>  
      </v-col>
      <v-col
        v-if="volas.length > 0"
        cols="2"
        class="pb-0 text-center"
      >
        <span class="font-weight-bold">End Date</span>  
      </v-col>
      <v-col
        v-if="volas.length > 0"
        cols="2"
        class="pb-0 text-center"
      >
        <span class="font-weight-bold">Amount (RM)</span>  
      </v-col>
      <v-col
        v-if="volas.length > 0"
        cols="2"
        class="pb-0 text-left"
      >
        <span class="font-weight-bold">Address</span>  
      </v-col>
      <v-col
        v-if="volas.length > 0"
        cols="2"
        class="pb-0 text-center"
      />
 
      <v-col
        v-if="volas.length > 0"
        cols="12"
        class="pt-0"
      >
        <v-row
          v-for="vola in volas"
          :key="vola.id"
          no-gutters
        >
          <v-col
            cols="2"
            class="text-left"
          >
            <v-tooltip
              bottom
              min-width="250"
            >
              <template v-slot:activator="{ on: tooltip }">
                <v-icon
                  class="pr-1"
                  small
                  color="info"
                  v-on="{ ...tooltip }"
                >
                  mdi-information-outline
                </v-icon>
              </template>
              <div>Created by: <b>{{ vola.created_by }}</b> on <b>{{ $moment(vola.created_at).format('DD-MM-YYYY') }}</b></div>
              <div>Updated by: <b>{{ vola.updated_by }}</b> on <b>{{ $moment(vola.updated_at).format('DD-MM-YYYY') }}</b></div>
            </v-tooltip>

            <span>{{ vola.benefit_in_kind.name }}</span>
          </v-col>
          <v-col
            cols="2"
            class="text-center px-3"
          >
            <span>{{ vola.start_date ? $moment(vola.start_date).format('D MMM YYYY'):'N/A' }}</span>
          </v-col>
          <v-col
            cols="2"
            class="text-center px-3"
          >
            <span>{{ vola.end_date ? $moment(vola.end_date).format('D MMM YYYY'):'N/A' }}</span>
          </v-col>
          <v-col
            cols="2"
            class="text-right px-3"
          >
            <span>{{ thousandSeparator(twoDigit(vola.amount)) }}</span>
          </v-col>

          <v-col
            cols="2"
            class="text-left px-3"
          >
            <span>{{ vola.address }}</span>
          </v-col>

          <v-col
            cols="2"
            class="text-center px-3"
          >
            <employee-profile-payroll-payroll-company-benefit-in-kind-vola-dialog-edit
              v-if="$hasPermissionTo(['update employee payroll']) && !companyEmployee.end_date && !vola.end_date"
              :vola="vola"
              :company-employee-start-date="companyEmployee.start_date"
              @updated="$emit('load')"
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col
        v-else
        class="py-0"
        cols="12"
      >
        <span>No Data Available</span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    components: {
      EmployeeProfilePayrollPayrollCompanyBenefitInKindBikDialogCreate: () => import('@/components/hris/employee/profile/payroll/payroll-company/benefit-in-kind/bik/DialogCreate'),
      EmployeeProfilePayrollPayrollCompanyBenefitInKindBikDialogEdit: () => import('@/components/hris/employee/profile/payroll/payroll-company/benefit-in-kind/bik/DialogEdit'),
      EmployeeProfilePayrollPayrollCompanyBenefitInKindPerquisiteDialogCreate: () => import('@/components/hris/employee/profile/payroll/payroll-company/benefit-in-kind/perquisite/DialogCreate'),
      EmployeeProfilePayrollPayrollCompanyBenefitInKindPerquisiteDialogEdit: () => import('@/components/hris/employee/profile/payroll/payroll-company/benefit-in-kind/perquisite/DialogEdit'),
      EmployeeProfilePayrollPayrollCompanyBenefitInKindVolaDialogCreate: () => import('@/components/hris/employee/profile/payroll/payroll-company/benefit-in-kind/vola/DialogCreate'),
      EmployeeProfilePayrollPayrollCompanyBenefitInKindVolaDialogEdit: () => import('@/components/hris/employee/profile/payroll/payroll-company/benefit-in-kind/vola/DialogEdit'),
    },
    props: {
      companyEmployee: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        benefitInKinds: [],
        perquisites: [],
        volas: [],
      }
    },
    watch: {
      companyEmployee: {
        immediate: true,
        handler (value) {
          if (value) {
            this.benefitInKinds = []
            this.perquisites = []
            this.volas = []

            if (value.company_employee_benefit_in_kinds.length > 0) {
              this.benefitInKinds = value.company_employee_benefit_in_kinds.filter(benefit => {
                return benefit.type === 'bik'
              })

              this.perquisites = value.company_employee_benefit_in_kinds.filter(benefit => {
                return benefit.type === 'perquisite'
              })

              this.volas = value.company_employee_benefit_in_kinds.filter(benefit => {
                return benefit.type === 'vola'
              })
            }
          }
        },
      },
    },
    methods: {
      twoDigit ($amount) {
        return (Math.round(($amount / 100) * 100) / 100).toFixed(2)
      },
      thousandSeparator (amount) {
        if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
          return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
          return amount
        }
      },
    },
    
  }
</script>
